import { render, staticRenderFns } from "./RentalDuration.vue?vue&type=template&id=184dcc7a"
import script from "./RentalDuration.vue?vue&type=script&lang=ts"
export * from "./RentalDuration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports